import connectToggleRefinement from "instantsearch.js/es/connectors/toggle-refinement/connectToggleRefinement.js";
import { useConnector } from "../hooks/useConnector.js";
export function useToggleRefinement(props, additionalWidgetProperties) {
  return useConnector(connectToggleRefinement, props, additionalWidgetProperties);
}